import ResourceModal from 'app/components/ResourceModal';
import CustomerUploadForm from './CustomerUploadForm';

const CustomerUploadModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    customer,
    center
  } = props;

  let action = 'create';
  let title = 'Upload Moments';
  let message = 'These moments will be added to the customer\'s gallery';
  let unmountOnClose = true;

  const onSubmit = params => onFormSubmit(action, params);

  return (
    <ResourceModal {...{ isOpen, onClose, title, message, unmountOnClose, center }}>
      <CustomerUploadForm {...{ action, onClose, onSubmit, customer }} />
    </ResourceModal>
  );
}

export default CustomerUploadModal;
